import React from 'react';

type Props = {
  color: string;
};

export const ColorSwatch = (props: Props) => {
  const { color } = props;
  return (
    <div
      style={{ backgroundColor: color }}
      className='size-6 rounded-full mr-2 border'
    />
  );
};
